import React from 'react'
import { useMutation, useQuery } from '@apollo/client';
import { NEW_LIKE_VIDEO } from '../../../../../graphql-client/Mutation';
import {CHECK_USER_LIKE_VIDEO} from '../../../../../graphql-client/Queries'
import { useParams } from 'react-router';
import { getDateIntVideo } from '../../../../../graphql-client/Queries';

export default function ButtonLikeVideo(props) {
    const {id}= useParams()
    const likeVideo = ()=>{
        created_like_video()
    }
    const [created_like_video] =  useMutation(NEW_LIKE_VIDEO,
        {
          variables: {videoId:id},
          refetchQueries: [
            { query: CHECK_USER_LIKE_VIDEO, variables: { videoId: id } },
          ],
          update:(cache, {data})=>{
              cache.writeQuery({
                query:getDateIntVideo,
                data:{
                  __typename: 'Video',
                  video: data.updateVideoLike.video
                }
              });
              cache.evict({ fieldName: 'videosLike' });
              cache.gc();
            },
        }
      );

    const handleLikeVideo =()=>{
      likeVideo();
    };

    const {data:videoLike, loading: loading1, error: error1} = useQuery(CHECK_USER_LIKE_VIDEO, 
        {
          variables: { videoId: id },
        }
      )
      if(loading1)return 'loading...'
      if(error1)return ' error'
     
    const dataCheckUserLike = videoLike.checkUserLikeVideo
  
    return (
            <div className="m-auto me-1 ms-1">
                <i 
                  className={
                      dataCheckUserLike !== null && dataCheckUserLike.video.id !== null
                      ?
                      "fas fa-heart"
                      :
                      "far fa-heart"
                   } 
                  onClick={()=>handleLikeVideo()}
                >
                </i>
            </div>
    )
}
